export const AMAZON_WWW_HOST = 'www.amazon.com';
export const AMAZON_HOST = 'amazon.com';
